import gql from "graphql-tag";

export default gql`
  query registrations($filter: RegistrationsFilter!) {
    registrations(filter: $filter) {
      id
      member {
        id
        firstName
        lastName
        emailAddress
        personalNote
      }
      canceled
      attended
      registrationDate
      tariffBooking {
        id
        creditCount
        tariff {
          id
          title
          tariffModel
          isTrialTariff
          isCompanyTariff
        }
      }
    }
  }
`;
